const TARIFF_BASIC = 3;
const TARIFF_PROFESSIONAL = 4;
const TARIFF_CORPORATE = 5;
const PROMO_ONE_DAY = 6;
const FREE = 8;

/**
 * Упорядоченное множество новых тарифов
 * @type {(number)[]}
 */
const TARIFFS = [
    TARIFF_BASIC,
    TARIFF_PROFESSIONAL,
    TARIFF_CORPORATE,
];

/**
 * Упорядоченное множество тарифов, в том числе и архивных тарифов.
 * Чтобы правильно определить на какой новый тариф пользователь может перейти с архивного.
 * @type {(number)[]}
 */
const ALL_TARIFFS = [
    FREE,
    TARIFF_BASIC,
    TARIFF_PROFESSIONAL,
    TARIFF_CORPORATE,
];

const PROMO_TARIFFS = [
];

const PROMO_TARIFFS_MAP = {
}

export default class Calculator {

    constructor(tariffNumber, srok) {
        this.tarif = parseInt(tariffNumber);
        this.tariffNumber = tariffNumber;
        if (this.isPromo()) {
            this.tarif = PROMO_TARIFFS_MAP[this.tarif]
        }
        this.srok = srok;
        this.price = [5300, 9300, 34900];
        this.ratio = [1, 0.9 * 3, 0.85 * 6, 0.75 * 12];
        this.days = [31, 92, 184, 366];
        this.period = [1, 3, 6, 12];
    }

    additionalFactor() {
        let date = new Date()
        // #promotion
        if ((new Date('2026-05-28T00:00:00+03:00')) < date && date < (new Date('2026-06-02T00:00:00+03:00'))) {
            return 0.8
        }
        return 1
    }

    getAmount(unusedAmount = 0) {
        return Math.round((this.getPrice() * this.ratio[this.srok] - unusedAmount)  * this.additionalFactor());
    }

    // Возвращается Стоимость тарифов от большей суммы к меньшей за год
    getAllPrices() {
        let prices = {
            [TARIFF_BASIC]: [],
            [TARIFF_PROFESSIONAL]: [],
            [TARIFF_CORPORATE]: []
        };

        for (let key = 0; key < this.price.length; key++) {
            let price = this.price[key];
            for (let key2 = 0; key2 < this.ratio.length; key2++) {
                let ratio = this.ratio[key2];
                const ratioPrice = Math.round(price * ratio);

                // Проверяем, существует ли массив перед добавлением
                if (!prices[TARIFFS[key]]) {
                    prices[TARIFFS[key]] = [];
                }

                // получаем стоимость дня и цену за период
                prices[TARIFFS[key]].push([Math.floor(ratioPrice / this.days[key2]), ratioPrice]);
            }
        }

        return prices;
    }

    isPromo() {
        return PROMO_TARIFFS.includes(this.tariffNumber);
    }

    getPrice() {
        const priceIdx = TARIFFS.indexOf(this.tarif)
        return this.price[priceIdx]
    }

    getDiscount() {
        return Math.round((this.getPrice() * this.period[this.srok]) - this.getAmount());
    }

    /**
     * Возвращает true, если tariffNumber >= this.tarif
     *
     * @param {number} tariffNumber
     * @returns {boolean}
     */
    gteThanCurrent(tariffNumber) {
        const currentTariffNumber = this.tarif;
        const tariffNumberIdx = ALL_TARIFFS.indexOf(tariffNumber) ?? -1;
        const currentTariffNumberIdx = ALL_TARIFFS.indexOf(currentTariffNumber) ?? -1;

        if (tariffNumberIdx === -1 || currentTariffNumberIdx === -1) {
            throw new Error(window.$t('lang.main.tariff_calculation_error'));
        }

        return tariffNumberIdx >= currentTariffNumberIdx;
    }

    /**
     * Возвращает следующий по старшинству новый тарифный план или этот же тариф, если он самый старший.
     *
     * @returns {number}
     */
    getNext() {
        /**
         * Если текущий тариф новый, то вернём следующий новый.
         * Если это самый крутой, то вернём его же.
         */
        const newTariffIndex = TARIFFS.indexOf(this.tarif);
        if (newTariffIndex !== -1) {
            return newTariffIndex < TARIFFS.length - 1 ? TARIFFS[newTariffIndex + 1] : TARIFFS[newTariffIndex];
        }

        return this.tarif;
    }
}

export {
    TARIFF_BASIC,
    TARIFF_PROFESSIONAL,
    TARIFF_CORPORATE,
    TARIFFS,
    FREE
}
